/* eslint-disable import/no-unresolved */
import React, { useMemo, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { MAIN_ICON_COLORS } from 'assets/components';
import { securityTOTPScreens } from '../constants';
import Icon from '../../../../components/Icon';
import { ICONS } from '../../../../components/Icon/constants';
import { SecurityTOTPContext } from '../../../../contexts/SecurityTOTP/context';

export const TFASteps = () => {
  const { t: translate } = useTranslation();

  const { state, updateTOTPSteps } = useContext(SecurityTOTPContext);

  const { state: locationState } = useLocation();

  const currentScreen = state?.currentScreen;
  const TOTPSteps = state?.TOTPSteps;

  const steps = useMemo(
    () => [
      {
        id: 1,
        label: translate('totp_step_1_title'),
        name: securityTOTPScreens.MAIN,
        icon: ICONS.PHONE,
        iconClass: 'pt-3',
        iconName: 'phone',
        active: currentScreen === securityTOTPScreens.MAIN,
        completed: TOTPSteps[securityTOTPScreens.MAIN].checked,
        lineClass: 'my-3',
        hidden: currentScreen === securityTOTPScreens.RESET_TFA || locationState?.resetSecretKey,
      },
      {
        id: 1,
        label: translate('totp_step_1_reset_secret_case_title'),
        name: securityTOTPScreens.RESET_TFA,
        icon: ICONS.PHONE,
        iconName: 'phone',
        active: currentScreen === securityTOTPScreens.RESET_TFA,
        completed: TOTPSteps[securityTOTPScreens.RESET_TFA].checked,
        lineClass: 'my-3',
        hidden: currentScreen === securityTOTPScreens.MAIN || !locationState?.resetSecretKey,
      },
      {
        id: 2,
        label: translate('totp_step_2_title'),
        name: securityTOTPScreens.SCAN,
        icon: ICONS.SCAN,
        iconName: 'phone',
        active: currentScreen === securityTOTPScreens.SCAN,
        completed: TOTPSteps[securityTOTPScreens.SCAN].checked,
        lineClass: 'my-2',
      },
      {
        id: 3,
        label: translate('totp_step_3_title'),
        name: securityTOTPScreens.SAVE,
        icon: ICONS.KEY,
        iconName: 'Key',
        active: currentScreen === securityTOTPScreens.SAVE,
        completed: TOTPSteps[securityTOTPScreens.SAVE].checked,
        lineClass: 'my-2',
      },
      {
        id: 4,
        label: translate('totp_step_4_title'),
        name: securityTOTPScreens.VERIFY,
        icon: ICONS.SHIELD,
        iconName: 'Shield',
        active: currentScreen === securityTOTPScreens.VERIFY,
        completed: TOTPSteps[securityTOTPScreens.VERIFY].checked,
        lineClass: 'my-2',
        iconClass: 'pt-3',
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [currentScreen, TOTPSteps, locationState]
  );

  const checkCompletedSteps = () => {
    const currentStepObj = steps.find((step) => step.name === currentScreen);

    if (currentStepObj) {
      const currentStepNumber = currentStepObj.id;
      steps.forEach((step) => {
        if (step.id < currentStepNumber) {
          updateTOTPSteps(step.name, true);
        }
      });
    }
  };

  useEffect(() => {
    if (steps) {
      checkCompletedSteps();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentScreen]);

  return (
    <div className="d-flex justify-content-center">
      <div className="d-flex flex-column justify-content-center mt-3 mt-md-4 pt-md-3 px-md-4">
        {/* mobile */}
        <p className="d-block d-md-none text-dark text-bold mx-3 text-f4">
          {translate('totp_steps_title')}
        </p>

        {/* browser */}
        <p className="d-none d-md-block text-dark text-bold mx-3 text-f3">
          {translate('totp_steps_title')}
        </p>
        <div className="mt-4 pt-3 mx-3">
          {steps
            .filter((step) => !step.hidden)
            .map((step, index) => (
              <div key={step?.id} className="d-flex flex-column">
                <div className="d-flex flex-row justify-content-start">
                  <div className={`d-flex flex-column align-items-center ${step?.iconClass}`}>
                    <div
                      className={`d-flex justify-content-center align-items-center border border-1 p-3 rounded-xl ${
                        step?.active ? 'border-primary' : 'border-disabled'
                      } ${step?.completed ? 'bg-primary' : ''}`}
                      style={{ width: '3.5rem', height: '3.5rem' }}>
                      {step?.icon && !step?.completed && (
                        <Icon
                          icon={step.icon}
                          color={step?.active ? MAIN_ICON_COLORS.PRIMARY : MAIN_ICON_COLORS.SHADOW}
                        />
                      )}
                      {step?.completed && (
                        <Icon icon={ICONS.CHECK} color={MAIN_ICON_COLORS.WHITE} />
                      )}
                    </div>
                    {index !== steps.filter((item) => !item.hidden).length - 1 && (
                      <div
                        className={`border border-1 border-disabled ${step?.lineClass}`}
                        style={{ height: '2rem', width: '1px' }}
                      />
                    )}
                  </div>
                  <div className="d-flex flex-column ms-4 mt-2">
                    <p
                      className={`text-f6 text-uppercase ${
                        step?.active ? 'text-primary' : 'text-shadow'
                      }`}>
                      {translate('totp_step_label').replace('__NUM__', step.id)}
                    </p>
                    <p
                      className={`text-f5 text-bold mt-1 ${
                        step?.active ? 'text-dark' : 'text-shadow'
                      }`}>
                      {step.label}
                    </p>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default TFASteps;
